import { useState } from "react";
import MenteeHeader from "../../components/MenteeHeader";
import Marketplace from "./MarketPlace";
import Purchases from "./Purchases";
import IndustryHub from "./IndustryHub";
import ScormCourseList from "../Scorm/ScormCourseList";
import { SCORM_ENABLED } from "../../helpers/scorm/featureFlag";
import useDashboardActiveTab from "../../hooks/useDashboardActiveTab";

export default function MenteeDashboard() {
  const role = localStorage.getItem("role");
  const [searchTerm, setSearchTerm] = useState("");
  const activeTab = useDashboardActiveTab("learn");

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <>
      <MenteeHeader
        role={role}
        active={activeTab}
        searchTerm={searchTerm}
        handleSearchChange={handleSearchChange}
      />
      {activeTab === "learn" && <Marketplace searchTerm={searchTerm} />}
      {activeTab === "myevents" && <Purchases searchTerm={searchTerm} />}
      {SCORM_ENABLED && activeTab === "training" && <ScormCourseList />}
      {activeTab == "industryhub" && <IndustryHub searchTerm={searchTerm} />}
    </>
  );
}
